import React from 'react';
import { Link } from 'react-router-dom';
import './styles.css';
import assetPreloader from '../../services/assetPreloader';

/**
 * Componente para exibir uma tela de fallback quando o usuário
 * estiver offline e o conteúdo solicitado não estiver disponível.
 */
function OfflineFallback({ message, availableRoutes = [] }) {
  // Estado do cache do aplicativo
  const [cacheStats, setCacheStats] = React.useState({
    totalCached: 0,
    availablePages: []
  });
  
  // Buscar informações do cache ao montar o componente
  React.useEffect(() => {
    const fetchCacheInfo = async () => {
      try {
        // Obter estatísticas do cache para todas as rotas
        let totalCached = 0;
        const availablePages = [];
        
        // Verificar cada rota disponível
        for (const route of availableRoutes) {
          const status = assetPreloader.getRouteAssetsStatus(route.path);
          
          // Se a rota tiver pelo menos 80% dos assets em cache, considerá-la disponível
          if (status.cachePercentage >= 80) {
            availablePages.push({
              ...route,
              cachePercentage: status.cachePercentage
            });
            
            totalCached += status.cachedAssets;
          }
        }
        
        setCacheStats({
          totalCached,
          availablePages
        });
      } catch (error) {
        console.error('Erro ao obter informações de cache:', error);
      }
    };
    
    fetchCacheInfo();
  }, [availableRoutes]);
  
  return (
    <div className="offline-fallback">
      <div className="offline-message">
        <div className="offline-icon">
          <div className="cloud"></div>
          <div className="cross"></div>
        </div>
        
        <h2>Você está offline</h2>
        <p>{message || 'Este conteúdo não está disponível sem conexão com a internet.'}</p>
        
        {cacheStats.availablePages.length > 0 && (
          <div className="available-pages">
            <h3>Páginas disponíveis offline:</h3>
            <ul className="offline-pages-list">
              {cacheStats.availablePages.map((route) => (
                <li key={route.path}>
                  <Link to={route.path} className="offline-page-link">
                    {route.name || route.path}
                    {route.cachePercentage < 100 && (
                      <span className="cache-percentage">({route.cachePercentage}%)</span>
                    )}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        )}
        
        <div className="offline-actions">
          <button 
            className="retry-button"
            onClick={() => window.location.reload()}
          >
            Tentar novamente
          </button>
          
          {availableRoutes.length > 0 && (
            <Link 
              to={availableRoutes[0].path} 
              className="home-button"
            >
              Ir para Início
            </Link>
          )}
        </div>
      </div>
    </div>
  );
}

export default OfflineFallback; 